export class Sfx {
  private context?: AudioContext;

  unlock(): void {
    if (!this.context) this.context = new AudioContext();
    if (this.context.state === 'suspended') void this.context.resume();
  }

  tone(frequency: number, duration = 0.06, volume = 0.025, slide = 0): void {
    if (!this.context || this.context.state !== 'running') return;
    const now = this.context.currentTime;
    const oscillator = this.context.createOscillator();
    const gain = this.context.createGain();
    oscillator.type = 'square';
    oscillator.frequency.setValueAtTime(frequency, now);
    oscillator.frequency.linearRampToValueAtTime(Math.max(50, frequency + slide), now + duration);
    gain.gain.setValueAtTime(volume, now);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);
    oscillator.connect(gain).connect(this.context.destination);
    oscillator.start(now);
    oscillator.stop(now + duration);
  }

  shot(): void { this.tone(210, 0.035, 0.012, -45); }
  hit(): void { this.tone(90, 0.07, 0.03, -30); }
  pickup(): void { this.tone(360, 0.09, 0.025, 180); }
  drop(): void { this.tone(150, 0.12, 0.03, -60); }
  patch(): void { this.tone(420, 0.25, 0.035, 380); }
  death(): void { this.tone(160, 0.48, 0.045, -110); }
}
